import createVueApp from '@phoenix/createVueApp';
import ProductSlider from '@maison/components/organisms/slider/ProductSlider.vue';

document.querySelectorAll('.phoenix-product-slider').forEach((el) => {
  const app = createVueApp();
  app.component('ProductSlider', ProductSlider);
  app.mount(el);
});
